export default __webpack_public_path__ + "static/media/stripe-dark.fdbe9cbe.svg";